export default __webpack_public_path__ + "static/media/DefaultMaps.4c4ef41e.mp4";